// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3qnNx","content":"LayoutSettings_content__1oalu"};